import { Link } from 'react-router-dom'
import { useResetPassword } from '../../model'
import { InputPassword } from '@/common/ui/Form'
import { Fieldset } from '@/common/ui/Form/Fieldset/Fieldset'
import { Button } from '@/common/ui/Form/Button'
import { AuthTabs } from '../shared/AuthTabs'
import { PASSWORD_VALIDATION } from '@/common/ui/Form'
import { ROUTES, RESET_TOKEN_ERROR } from '../../lib/constants'

export const ResetPasswordForm = () => {
    const { register, handleSubmit, errors, onSubmit, mutation, isValidToken } = useResetPassword()

    if (!isValidToken) {
        return (
            <>
                {errors.root?.message === RESET_TOKEN_ERROR.EXPIRED ? (
                    <>
                        <p>Время для сброса пароля истекло.</p>
                        <p>
                            Выполните{' '}
                            <Link to={ROUTES.AUTH.RECOVERY} className='underline'>
                                восстановление пароля
                            </Link>{' '}
                            повторно.
                        </p>
                    </>
                ) : (
                    <>
                        <p>Токен недействителен. {errors.root?.message}</p>
                        <p>
                            Вернуться на{' '}
                            <Link to={ROUTES.APP} className='underline'>
                                главную страницу
                            </Link>
                            .
                        </p>
                    </>
                )}
            </>
        )
    }

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            aria-label='Форма восстановления пароля'
            className='w-full flex flex-col gap-[1.875rem]'
        >
            <AuthTabs />
            <Fieldset errorText={errors.new_password?.message} required>
                <span className='block text-[1.25rem] mb-[0.938rem]'>Новый пароль</span>
                <InputPassword
                    size='lg'
                    placeholder='Придумайте пароль'
                    className='w-full'
                    aria-label='Придумайте пароль'
                    autoComplete='off'
                    {...register('new_password', { required: PASSWORD_VALIDATION.required })}
                />
            </Fieldset>
            <Fieldset errorText={errors.new_password_confirm?.message} required>
                <InputPassword
                    size='lg'
                    placeholder='Подтвердите пароль'
                    className='w-full'
                    aria-label='Подтвердите пароль'
                    autoComplete='off'
                    {...register('new_password_confirm', { required: PASSWORD_VALIDATION.required })}
                />
            </Fieldset>
            {errors.root && <div className='input-error text-center text-sm'>{errors.root.message}</div>}
            <Button
                type='submit'
                variant='filled'
                emphasis='accent'
                size='xl'
                className='w-full'
                aria-label='Сохранить'
                disabled={mutation.isPending}
                loading={mutation.isPending}
            >
                Сохранить
            </Button>
        </form>
    )
}
